/**
 * Product FAQ accordion.
 *
 * Answers are server-rendered and only toggled with CSS so crawlers still read
 * every answer in the initial HTML.
 */
(function () {
	"use strict";

	function closeItem(button, answer) {
		button.setAttribute("aria-expanded", "false");
		answer.classList.remove("is-open");
	}

	function openItem(button, answer) {
		button.setAttribute("aria-expanded", "true");
		answer.classList.add("is-open");
	}

	function init() {
		var list = document.querySelector(".product-faq__list");

		if (!list) {
			return;
		}

		list.addEventListener("click", function (event) {
			var button = event.target.closest(".product-faq__question");

			if (!button || !list.contains(button)) {
				return;
			}

			var answer = document.getElementById(
				button.getAttribute("aria-controls")
			);

			if (!answer) {
				return;
			}

			var isOpen = button.getAttribute("aria-expanded") === "true";

			// Only one answer open at a time, matching the jh/questions block.
			list.querySelectorAll(".product-faq__question").forEach(function (
				other
			) {
				if (other === button) {
					return;
				}

				var otherAnswer = document.getElementById(
					other.getAttribute("aria-controls")
				);

				if (otherAnswer) {
					closeItem(other, otherAnswer);
				}
			});

			if (isOpen) {
				closeItem(button, answer);
			} else {
				openItem(button, answer);
			}
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
